import { Box, BoxProps, useColorModeValue } from '@chakra-ui/react';
import { Header } from '@tanstack/react-table';

export function Resizer<T>({
  header,
  ...boxProps
}: {
  header: Header<T, unknown>;
} & BoxProps) {
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box
      display="inline-block"
      backgroundColor={header.column.getIsResizing() ? 'gray.500' : undefined}
      position="absolute"
      top={1.5}
      bottom={1.5}
      right={0}
      borderRight={`1px solid`}
      borderColor={borderColor}
      width={1}
      opacity={header.column.getIsResizing() ? 0.4 : 1}
      _hover={{ opacity: 0.5 }}
      sx={{ touchAction: 'none' }}
      cursor={'col-resize'}
      draggable={false}
      role="separator"
      onMouseDown={header.getResizeHandler()}
      {...boxProps}
    />
  );
}
